import axios from "axios"
const server = "https://transportation-backend-test.link"

export const fetchCurrency = async (groupId) => {
  const { data } = await axios.get(
    `${server}/projects-info/${groupId}`
  )

  return data[0].currency
}